/* eslint-disable no-template-curly-in-string */

import * as yup from 'yup'
import { IShipment } from '../types/CreateLoadSchema'
import { MotorCarrierSchema } from './MotorCarrierSchema'
import { ShipmentDriverSchema } from './ShipmentDriverSchema'
import { isAssociatedDispatcher, isAssociatedDriver, hasDriver, IValidationContext } from './utils'

const requiredMessage = 'This field is required'

type TRequiredContextFields =
  | 'isRoleTypeForCarrier'
  | 'isAssociatedCarrier'
  | 'isAdminForCarrier'
  | 'isFpCarrierPortalEnabled'
  | 'isDriverRequired'

export interface ILoadAssignmentSchemaContext
  extends Required<Pick<IValidationContext, TRequiredContextFields>> {}

type TSelectedProps =
  | 'dispatcherId'
  | 'drivers'
  | 'motorCarrierId'
  | 'motorCarrier'
  | 'trailerId'
  | 'truckId'

interface IShipmentWithVin extends Pick<IShipment, TSelectedProps> {
  tractorVin?: string | null
}

export const LoadAssignmentSchema = yup.object<IShipmentWithVin>({
  dispatcherId: yup
    .mixed()
    .required(requiredMessage)
    .test(
      'is-associated-dispatcher',
      'This dispatcher doesn’t have permission to manage loads for this carrier. To give them permission, you need to be an Admin for this carrier.',
      isAssociatedDispatcher
    ),
  drivers: yup
    .array()
    .of(ShipmentDriverSchema)
    .test(
      'is-associated-driver',
      'unused error string', // we use a custom one later in this function
      isAssociatedDriver
    )
    .test(
      'has-a-driver',
      'You need to assign a driver for a load in progress. If you need help, please contact us.',
      hasDriver
    )
    .ensure(),
  motorCarrierId: yup.number().required(requiredMessage),
  motorCarrier: MotorCarrierSchema.required(requiredMessage),
  trailerId: yup.string().nullable().notRequired().default(null),
  truckId: yup.string().notRequired().nullable().default(null),
  /**
   * Should be at least 4 characters long
   */
  tractorVin: yup
    .string()
    .notRequired()
    .test('has-4-characters', 'Tractor VIN # must be at least 4 characters', (val: string = '') => {
      return val ? val.length >= 4 : true
    }),
})

export type LoadAssignmentSchemaType = yup.InferType<typeof LoadAssignmentSchema>
